import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import { useAuth } from '../../context/AuthContext';
import ConfirmModal from '../../components/ConfirmModal';
import api from '../../api/axios';
import { ShieldCheck, Settings,  Plus, Search, Edit2, Filter, Trash2, Upload, Download, FileSpreadsheet, Smartphone, RefreshCw, CheckCircle2, AlertCircle } from 'lucide-react';
import * as XLSX from 'xlsx';

export default function AdminUsers() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [confirmModal, setConfirmModal] = React.useState({ open: false, action: null, title: '', message: '' });
  const showConfirm = (title, message, action) => setConfirmModal({ open: true, title, message, action });
  const closeConfirm = () => setConfirmModal({ open: false, action: null, title: '', message: '' });
  
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [filterCompany, setFilterCompany] = useState('');
  
  const [showModal, setShowModal] = useState(false);
  const [paramsModal, setParamsModal] = useState(false);
  const [activeParamTab, setActiveParamTab] = useState('company');
  const [newParamValue, setNewParamValue] = useState('');
  const [sysParams, setSysParams] = useState({ company: [], department: [], unit: [], title: [] });

  const fetchParams = () => {
    fetch('/api/parameters')
      .then(res => res.json())
      .then(data => { if (!data.error) setSysParams(data); })
      .catch(console.error);
  };

  const handleAddParam = async (e) => {
    e.preventDefault();
    if (!newParamValue.trim()) return;
    try {
      await fetch('/api/parameters', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: activeParamTab, value: newParamValue.trim().toUpperCase() })
      });
      setNewParamValue('');
      fetchParams();
    } catch (err) { console.error(err); }
  };

  const handleDeleteParam = async (type, value) => {
    if (!window.confirm(`"${value}" kaydını silmek istediğinize emin misiniz?`)) return;
    try {
      await fetch(`/api/parameters/${type}/${encodeURIComponent(value)}`, { method: 'DELETE' });
      fetchParams();
    } catch (err) { console.error(err); }
  };

  useEffect(() => {
    fetchParams();
  }, []);
  const [editModal, setEditModal] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', username: '', password: '', role: 'student', company: '', department: '', title: '', phone: '' });
  
  const [createError, setCreateError] = useState('');
  const [createSuccess, setCreateSuccess] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  
  const [importModal, setImportModal] = useState(false);
  const [importData, setImportData] = useState([]);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  
  const [phoneImportData, setPhoneImportData] = useState([]);
  const [phoneImportResult, setPhoneImportResult] = useState(null);
  const [phoneImporting, setPhoneImporting] = useState(false);
  
  const [bulkUpdateModal, setBulkUpdateModal] = useState(false);
  const [bulkUpdateData, setBulkUpdateData] = useState([]);
  const [bulkUpdatePreview, setBulkUpdatePreview] = useState(null);
  const [bulkUpdating, setBulkUpdating] = useState(false);

  const [editForm, setEditForm] = useState({ name: '', email: '', phone: '', role: 'student', is_active: true, password: '' });
  const [saving, setSaving] = useState(false);
  
  const [page, setPage] = useState(1);
  const perPage = 50;

  useEffect(() => { api.get('/users').then(r => setUsers(r.data)); }, []);
  const companies = [...new Set(users.map(u => u.company).filter(Boolean))].sort();

  const createUser = async () => {
    setCreateError('');
    try {
      await api.post('/users', form);
      const r = await api.get('/users');
      setUsers(r.data);
      setCreateSuccess(true);
      setTimeout(() => {
        setShowModal(false);
        setCreateSuccess(false);
        setForm({ name: '', email: '', username: '', password: '', role: 'student', company: '', department: '', title: '', phone: '' });
      }, 1500);
    } catch(e) {
      setCreateError(e.response?.data?.error || 'Kullanıcı oluşturulamadı');
    }
  };

    const [downloadingKvkk, setDownloadingKvkk] = useState(false);

  const exportKvkkExcel = async () => {
    try {
      setDownloadingKvkk(true);
      const res = await api.get('/reports/kvkk-consents');
      const users = res.data || [];

      if (users.length === 0) {
        alert('Kullanıcı verisi bulunamadı.');
        setDownloadingKvkk(false);
        return;
      }

      const rows = users.map(u => ({
        'SİCİL': u.username || '',
        'ADI SOYADI': u.name || '',
        'ŞİRKET': u.company || '',
        'DEPARTMAN / MÜDÜRLÜK': u.department || '',
        'BİRİM / ŞEFLİK': u.unit || '',
        'UNVAN': u.title || '',
        'HESAP DURUMU': u.is_active ? 'Aktif' : 'Pasif',
        'KVKK ONAY DURUMU': u.kvkk_accepted_at ? 'Onaylandı' : 'Bekliyor',
        'ONAY TARİHİ': u.kvkk_accepted_at ? new Date(u.kvkk_accepted_at).toLocaleString('tr-TR') : '-',
        'ONAY IP ADRESİ': u.kvkk_accepted_ip || '-'
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet['!cols'] = [
        { wch: 12 }, { wch: 25 }, { wch: 20 }, { wch: 28 },
        { wch: 24 }, { wch: 24 }, { wch: 15 }, { wch: 18 },
        { wch: 22 }, { wch: 18 }
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'KVKK Onay Listesi');

      const dateStr = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(workbook, 'KVKK-Aydinlatma-Onay-Raporu-' + dateStr + '.xlsx');
    } catch (err) {
      console.error('KVKK raporu hatası:', err);
      alert('Hata oluştu: ' + (err.response?.data?.error || err.message));
    } finally {
      setDownloadingKvkk(false);
    }
  };

const downloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([
      ['AD SOYAD', 'SİCİL', 'PAROLA', 'E-POSTA', 'TELEFON', 'ŞİRKET', 'MÜDÜRLÜK', 'UNVAN'],
      ['AHMET YILMAZ', '12345', 'P12345', 'ahmet@sirket.com', '05001234567', 'PETLAS', 'ÜRETİM MÜDÜRLÜĞÜ', 'MÜHENDİS'],
      ['AYŞE KAYA', '67890', 'P67890', 'ayse@sirket.com', '05001234568', 'PETLAS', 'İK MÜDÜRLÜĞÜ', 'UZMAN'],
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Kullanıcılar');
    XLSX.writeFile(wb, 'kullanici-sablonu.xlsx');
  };

  const exportUsersToExcel = () => {
    if (!users.length) {
      alert('Aktarılacak kullanıcı bulunamadı.');
      return;
    }
    const formatDate = (value) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      return date.toLocaleString('tr-TR');
    };
    const roleLabels = { student: 'Öğrenci', admin: 'Admin', manager: 'Yönetici' };
    const exportData = users.map(u => ({
      'AD SOYAD': u.name || '',
      'SİCİL': u.username || '',
      'E-POSTA': u.email || '',
      'TELEFON': u.phone || '',
      'ŞİRKET': u.company || '',
      'MÜDÜRLÜK': u.department || '',
      'BİRİM': u.unit || '',
      'UNVAN': u.title || '',
      'ROL': roleLabels[u.role] || u.role || '',
      'DURUM': u.is_active ? 'Aktif' : 'Pasif',
      'OLUŞTURULMA TARİHİ': formatDate(u.created_at),
      'GÜNCELLENME TARİHİ': formatDate(u.updated_at)
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    ws['!cols'] = [{ wch: 28 }, { wch: 14 }, { wch: 32 }, { wch: 20 }, { wch: 22 }, { wch: 32 }, { wch: 30 }, { wch: 28 }, { wch: 14 }, { wch: 12 }, { wch: 22 }, { wch: 22 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Kullanıcılar');
    const tarih = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `kullanicilar-${tarih}.xlsx`);
  };

  const handleExcelFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const wb = XLSX.read(evt.target.result, { type: 'binary' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const headers = data[0].map(h => h?.toString().toLowerCase().trim());
      const rows = data.slice(1).filter(row => row.some(cell => cell));
      const imported = rows.map(row => ({
        name: row[headers.findIndex(h => h.includes('ad') || h.includes('soyad'))] || '',
        username: row[headers.findIndex(h => h.includes('sicil'))] || '',
        password: row[headers.findIndex(h => h.includes('parola') || h.includes('şifre'))] || '',
        email: row[headers.findIndex(h => h.includes('e-posta') || h.includes('mail'))] || '',
        company: row[headers.findIndex(h => h.includes('şirket'))] || '',
        department: row[headers.findIndex(h => h.includes('müdürlük') || h.includes('departman'))] || '',
        phone: row[headers.findIndex(h => h.includes('telefon') || h.includes('phone'))] || '',
        title: row[headers.findIndex(h => h.includes('unvan'))] || '',
      })).filter(u => u.name && u.username && u.password);
      setImportData(imported);
      setImportResult(null);
    };
    reader.readAsBinaryString(file);
  };

  const handleBulkUpdateExcelFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (!data.length) { alert('Excel dosyası boş.'); return; }

        const normalizeHeader = (value) => String(value ?? '').trim().toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/İ/g, 'i').replace(/[^a-z0-9]/g, '');
        const headers = data[0].map(normalizeHeader);
        const findHeader = (...names) => {
          const normalizedNames = names.map(normalizeHeader);
          return headers.findIndex(h => normalizedNames.some(n => h.includes(n)));
        };

        const sicilIndex = findHeader('sicil');
        const nameIndex = findHeader('ad soyad', 'adsoyad');
        const emailIndex = findHeader('e-posta', 'eposta', 'email', 'mail');
        const phoneIndex = findHeader('telefon', 'phone');
        const companyIndex = findHeader('şirket', 'sirket', 'company');
        const departmentIndex = findHeader('müdürlük', 'mudurluk', 'departman', 'department');
        const unitIndex = findHeader('birim', 'unit');
        const titleIndex = findHeader('unvan', 'ünvan', 'title');
        const roleIndex = findHeader('rol', 'role');
        const statusIndex = findHeader('durum', 'status');

        if (sicilIndex === -1) { alert('Excel dosyasında SİCİL sütunu bulunamadı.'); return; }

        const rows = data.slice(1).filter(row => row.some(cell => cell !== undefined && cell !== null && cell !== ''));
        const importedUsers = rows.map(row => ({
          username: String(row[sicilIndex] ?? '').trim(),
          name: nameIndex >= 0 ? String(row[nameIndex] ?? '').trim() : '',
          email: emailIndex >= 0 ? String(row[emailIndex] ?? '').trim() : '',
          phone: phoneIndex >= 0 ? String(row[phoneIndex] ?? '').trim() : '',
          company: companyIndex >= 0 ? String(row[companyIndex] ?? '').trim() : '',
          department: departmentIndex >= 0 ? String(row[departmentIndex] ?? '').trim() : '',
          unit: unitIndex >= 0 ? String(row[unitIndex] ?? '').trim() : '',
          title: titleIndex >= 0 ? String(row[titleIndex] ?? '').trim() : '',
          role: roleIndex >= 0 ? String(row[roleIndex] ?? '').trim() : '',
          is_active: statusIndex >= 0 ? String(row[statusIndex] ?? '').trim() : 'Aktif'
        })).filter(u => u.username);

        if (!importedUsers.length) { alert('Güncellenecek kayıt bulunamadı.'); return; }

        const existingUsernames = new Set(users.map(u => String(u.username || '').trim()));
        const found = importedUsers.filter(u => existingUsernames.has(u.username));
        const notFound = importedUsers.filter(u => !existingUsernames.has(u.username));
        const uniqueUsernames = new Set(importedUsers.map(u => u.username));

        setBulkUpdateData(importedUsers);
        setBulkUpdatePreview({ total: importedUsers.length, found: found.length, notFound: notFound.map(u => u.username), duplicate: importedUsers.length - uniqueUsernames.size });
        setBulkUpdateModal(true);
      } catch (err) { alert('Excel dosyası okunamadı.'); }
    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  };

  const executeBulkUpdate = async () => {
    if (!bulkUpdateData.length) return;
    setBulkUpdating(true);
    try {
      const response = await api.put('/users/bulk-update', { users: bulkUpdateData });
      const r = await api.get('/users');
      setUsers(r.data);
      setBulkUpdatePreview({
        total: bulkUpdateData.length, found: response.data.updated || 0, updated: response.data.updated || 0,
        notFound: response.data.notFound || [], errors: response.data.errors || []
      });
    } catch (e) {
      alert(e.response?.data?.error || 'Kullanıcılar güncellenirken bir hata oluştu.');
    } finally {
      setBulkUpdating(false);
    }
  };

  const handlePhoneExcelFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: 'binary' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (!data.length) { alert('Excel dosyası boş.'); return; }
        const headers = data[0].map(h => h?.toString().toLowerCase().trim());
        const sicilIndex = headers.findIndex(h => h.includes('sicil'));
        const phoneIndex = headers.findIndex(h => h.includes('telefon') || h.includes('phone'));
        if (sicilIndex === -1 || phoneIndex === -1) { alert('Excel dosyasında SİCİL ve TELEFON sütunları bulunamadı.'); return; }
        const rows = data.slice(1).filter(row => row.some(cell => cell));
        const imported = rows.map(row => ({ username: String(row[sicilIndex] ?? '').trim(), phone: String(row[phoneIndex] ?? '').trim() })).filter(u => u.username && u.phone);
        if (!imported.length) { alert('Güncellenecek kayıt bulunamadı.'); return; }
        setPhoneImportData(imported);
        setPhoneImportResult(null);
      } catch (err) { alert('Excel dosyası okunamadı.'); }
    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  };

  const importPhones = async () => {
    if (!phoneImportData.length) return;
    setPhoneImporting(true); setPhoneImportResult(null);
    try {
      const response = await api.put('/users/bulk-phone', { users: phoneImportData });
      const r = await api.get('/users');
      setUsers(r.data);
      setPhoneImportResult({ success: true, updated: response.data.updated || 0, notFound: response.data.notFound || [], emptyPhone: response.data.emptyPhone || [] });
    } catch (e) {
      setPhoneImportResult({ success: false, error: e.response?.data?.error || 'Telefonlar güncellenemedi.' });
    } finally { setPhoneImporting(false); }
  };

  const importUsers = async () => {
    setImporting(true);
    let added = 0, skipped = 0, errors = [];
    for (const u of importData) {
      try {
        await api.post('/users', { ...u, role: 'student' });
        added++;
      } catch(e) {
        const msg = e.response?.data?.error || 'Hata';
        if (msg.includes('zaten')) skipped++;
        else errors.push(u.name + ': ' + msg);
      }
    }
    const r = await api.get('/users');
    setUsers(r.data);
    setImportResult({ added, skipped, errors });
    setImporting(false);
  };

  const deleteUser = (u) => {
    showConfirm('Kullanıcıyı Sil', u.name + ' adlı kullanıcıyı silmek istediğinize emin misiniz?', async () => {
      try {
        await api.delete('/users/' + u.id);
        setUsers(prev => prev.filter(x => x.id !== u.id));
      } catch(e) { alert(e.response?.data?.error || 'Silinemedi'); }
      closeConfirm();
    });
  };

  const openEdit = (u) => {
    setEditForm({
      name: u.name || '', username: u.username || '', email: u.email || '', phone: u.phone || '',
      company: u.company || '', department: u.department || '', unit: u.unit || '',
      title: u.title || '', role: u.role || 'student', is_active: u.is_active !== false, password: ''
    });
    setEditModal(u);
  };

  const saveEdit = async () => {
    setSaving(true);
    try {
      await api.put('/users/' + editModal.id, editForm);
      if (editForm.password && editForm.password.trim()) {
        await api.post('/users/' + editModal.id + '/change-password', { password: editForm.password });
      }
      const r = await api.get('/users');
      setUsers(r.data);
      setEditModal(null);
      setUpdateSuccess(true);
    } catch (e) {
      alert(e.response?.data?.error || 'Kullanıcı bilgileri güncellenirken bir hata oluştu.');
    } finally { setSaving(false); }
  };

  const [columnFilters, setColumnFilters] = useState({ name: '', username: '', email: '', phone: '', company: '', department: '', unit: '', title: '', status: '' });

  const updateColumnFilter = (key, value) => {
    setColumnFilters(prev => ({ ...prev, [key]: value }));
    setPage(1);
  };

  const normalizeFilterText = (value) => String(value ?? '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i');

  const filtered = users.filter(u => {
    const matchSearch = !search || normalizeFilterText(u.name).includes(normalizeFilterText(search)) || normalizeFilterText(u.email).includes(normalizeFilterText(search)) || normalizeFilterText(u.username).includes(normalizeFilterText(search)) || normalizeFilterText(u.department).includes(normalizeFilterText(search)) || normalizeFilterText(u.unit).includes(normalizeFilterText(search));
    const matchCompany = !filterCompany || u.company === filterCompany;
    const matchColumnFilters = normalizeFilterText(u.name).includes(normalizeFilterText(columnFilters.name)) && normalizeFilterText(u.username).includes(normalizeFilterText(columnFilters.username)) && normalizeFilterText(u.email).includes(normalizeFilterText(columnFilters.email)) && normalizeFilterText(u.phone).includes(normalizeFilterText(columnFilters.phone)) && normalizeFilterText(u.company).includes(normalizeFilterText(columnFilters.company)) && normalizeFilterText(u.department).includes(normalizeFilterText(columnFilters.department)) && normalizeFilterText(u.unit).includes(normalizeFilterText(columnFilters.unit)) && normalizeFilterText(u.title).includes(normalizeFilterText(columnFilters.title)) && (!columnFilters.status || (columnFilters.status === 'active' && u.is_active) || (columnFilters.status === 'inactive' && !u.is_active));
    return matchSearch && matchCompany && matchColumnFilters;
  });

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  return (
    <AdminLayout>
      <div className="page-container">
        
        {/* Üst Başlık ve Aksiyon Butonları */}
        <div className="page-header">
          <div>
            <h2 className="page-title">Kullanıcılar</h2>
            <p className="page-subtitle">Sistemdeki tüm kullanıcıları yönetin ve yetkilendirin.</p>
          </div>

          <div className="header-actions">
            <button onClick={exportKvkkExcel} disabled={downloadingKvkk} className="btn-outline-blue" title="KVKK Aydınlatma Onay Listesini Excel Olarak İndir">
              <ShieldCheck size={15} /> {downloadingKvkk ? 'İndiriliyor...' : 'KVKK Raporu'}
            </button>

            <button onClick={downloadTemplate} className="btn-outline-blue">
              <Download size={15} /> Şablon İndir
            </button>

            <button onClick={exportUsersToExcel} className="btn-outline-green">
              <FileSpreadsheet size={15} /> Excel'e Aktar
            </button>

            <label className="btn-outline-green cursor-pointer">
              <Upload size={15} /> Yeni Kullanıcı Aktar
              <input type="file" accept=".xlsx,.xls" onChange={e => { handleExcelFile(e); setImportModal(true); e.target.value=''; }} style={{ display: 'none' }} />
            </label>

            <label className="btn-outline-orange cursor-pointer">
              <Smartphone size={15} /> Telefon Güncelle
              <input type="file" accept=".xlsx,.xls" onChange={handlePhoneExcelFile} style={{ display: 'none' }} />
            </label>

            <label className="btn-outline-indigo cursor-pointer">
              <RefreshCw size={15} /> Excel'den Güncelle
              <input type="file" accept=".xlsx,.xls" onChange={handleBulkUpdateExcelFile} style={{ display: 'none' }} />
            </label>

            <button onClick={() => { setShowModal(true); setCreateError(''); setCreateSuccess(false); }} className="btn-primary">
              <Plus size={16} strokeWidth={2.5} /> Yeni Kullanıcı
            </button>
          </div>
        </div>

        {/* Ana İçerik Kartı */}
        <div className="content-card">
          
          {/* Üst Filtre Çubuğu */}
          <div className="search-bar-container">
            <div className="search-input-wrapper">
              <Search size={16} className="search-icon" />
              <input 
                placeholder="Ad, sicil, müdürlük vb. ara..." 
                value={search} 
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                className="search-input" 
              />
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div className="filter-select-wrapper">
                <Filter size={15} className="filter-icon" />
                <select 
                  value={filterCompany} 
                  onChange={e => { setFilterCompany(e.target.value); setPage(1); }}
                  className="filter-select"
                >
                  <option value="">Tüm Şirketler</option>
                  {companies.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="result-count">Toplam <strong>{filtered.length}</strong> kullanıcı</div>
            </div>
          </div>

          {/* Tablo */}
          <div className="table-responsive">
            <table className="modern-table">
              <thead>
                <tr>
                  {['AD SOYAD', 'SİCİL', 'E-POSTA', 'TELEFON', 'ŞİRKET', 'MÜDÜRLÜK', 'BİRİM / ŞEFLİK', 'UNVAN', 'DURUM', 'İŞLEM'].map(h => (
                    <th key={h}>{h}</th>
                  ))}
                </tr>
                {/* Kolon Filtreleri */}
                <tr className="column-filters-row">
                  {[
                    ['name', 'Ad Soyad'], ['username', 'Sicil'], ['email', 'E-posta'], ['phone', 'Telefon'],
                    ['company', 'Şirket'], ['department', 'Müdürlük'], ['unit', 'Birim'], ['title', 'Ünvan']
                  ].map(([key, placeholder]) => (
                    <th key={key}>
                      <input type="text" value={columnFilters[key]} onChange={e => updateColumnFilter(key, e.target.value)} placeholder={`${placeholder} ara..`} className="col-filter-input" />
                    </th>
                  ))}
                  <th>
                    <select value={columnFilters.status} onChange={e => updateColumnFilter('status', e.target.value)} className="col-filter-input">
                      <option value="">Tümü</option>
                      <option value="active">Aktif</option>
                      <option value="inactive">Pasif</option>
                    </select>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {paginated.map(u => (
                  <tr key={u.id}>
                    <td className="font-medium text-dark">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div className="avatar-circle">{u.name.charAt(0).toUpperCase()}</div>
                        {u.name}
                      </div>
                    </td>
                    <td className="text-monospace text-muted">{u.username}</td>
                    <td className="text-muted text-truncate" style={{ maxWidth: 180 }} title={u.email}>{u.email || '—'}</td>
                    <td className="text-muted white-space-nowrap">{u.phone || '—'}</td>
                    <td>{u.company && <span className="badge category-badge">{u.company}</span>}</td>
                    <td className="text-muted text-truncate" style={{ maxWidth: 160 }} title={u.department}>{u.department || '—'}</td>
                    <td className="text-muted text-truncate" style={{ maxWidth: 160 }} title={u.unit}>{u.unit || '—'}</td>
                    <td>{u.title && <span className="badge title-badge">{u.title}</span>}</td>
                    <td>
                      <span className={`badge ${u.is_active ? 'status-active' : 'status-passive'}`}>
                        {u.is_active ? 'Aktif' : 'Pasif'}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button onClick={() => openEdit(u)} className="btn-icon-edit" title="Düzenle">
                          <Edit2 size={14} />
                        </button>
                        {isAdmin && (
                          <button onClick={() => deleteUser(u)} className="btn-icon-danger" title="Sil">
                            <Trash2 size={14} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                {paginated.length === 0 && (
                  <tr>
                    <td colSpan="10" className="empty-state">Kullanıcı bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Sayfalama */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="btn-pagination">← Önceki</button>
              <span className="pagination-info">{page} / {totalPages}</span>
              <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} className="btn-pagination">Sonraki →</button>
            </div>
          )}
        </div>
      </div>

      {/* --- MODALLAR --- */}

      {/* 1. Yeni Kullanıcı Modalı */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: 560 }}>
            <div className="modal-header d-flex justify-between align-center">
              <h3 className="modal-title">Yeni Kullanıcı Oluştur</h3>
              <button type="button" onClick={() => setParamsModal(true)} className="btn-secondary d-flex align-center gap-1" style={{ padding: '6px 12px', fontSize: '13px', background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '6px', color: '#475569', cursor: 'pointer', transition: 'all 0.2s' }}>
                <Settings size={14} /> Sistem Tanımları
              </button>
            </div>
            <div className="modal-body">
              {createSuccess && <div className="alert-success mb-4"><CheckCircle2 size={16}/> Kullanıcı başarıyla oluşturuldu!</div>}
              {createError && <div className="alert-danger mb-4"><AlertCircle size={16}/> {createError}</div>}
              
              <div className="form-grid">
                <div className="form-group span-full">
                  <label className="form-label">AD SOYAD *</label>
                  <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="form-input" />
                </div>
                <div className="form-group">
                  <label className="form-label">SİCİL NO *</label>
                  <input
  type="text"
  name="new-user-username"
  autoComplete="new-username"
  value={form.username}
  onChange={e => setForm({...form, username: e.target.value})}
  className="form-input"
/>
                </div>
                <div className="form-group">
                  <label className="form-label">PAROLA *</label>
                  <input
  type="password"
  name="new-user-password"
  autoComplete="new-password"
  value={form.password}
  onChange={e => setForm({...form, password: e.target.value})}
  className="form-input"
/>
                </div>
                <div className="form-group">
                  <label className="form-label">E-POSTA</label>
                  <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="form-input" />
                </div>
                <div className="form-group">
                  <label className="form-label">TELEFON</label>
                  <input type="tel" placeholder="05XX XXX XX XX" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="form-input" />
                </div>
                <div className="form-group">
                  <label className="form-label">ŞİRKET</label>
                  <input list="company-list" value={form.company || ''} onChange={e => setForm({...form, company: e.target.value})} className="form-input" placeholder="Seçiniz veya yazınız..." autoComplete="off" />
                  <datalist id="company-list">
                    {sysParams.company?.map((item, idx) => <option key={idx} value={item} />)}
                  </datalist>
                </div>
                <div className="form-group">
                  <label className="form-label">MÜDÜRLÜK</label>
                  <input list="department-list" value={form.department || ''} onChange={e => setForm({...form, department: e.target.value})} className="form-input" placeholder="Seçiniz veya yazınız..." autoComplete="off" />
                  <datalist id="department-list">
                    {sysParams.department?.map((item, idx) => <option key={idx} value={item} />)}
                  </datalist>
                </div>
                <div className="form-group">
                  <label className="form-label">BİRİM / ŞEFLİK</label>
                  <input type="search" list="unit-list" value={form.unit || ''} onChange={e => setForm({...form, unit: e.target.value})} onFocus={e => e.target.select()} className="form-input" placeholder="Seçiniz veya yazınız..." autoComplete="off" />
                  <datalist id="unit-list">
                    {sysParams.unit?.map((item, idx) => <option key={idx} value={item} />)}
                  </datalist>
                </div>
                <div className="form-group">
                  <label className="form-label">ÜNVAN</label>
                  <input list="title-list" value={form.title || ''} onChange={e => setForm({...form, title: e.target.value})} className="form-input" placeholder="Seçiniz veya yazınız..." autoComplete="off" />
                  <datalist id="title-list">
                    {sysParams.title?.map((item, idx) => <option key={idx} value={item} />)}
                  </datalist>
                </div>
                <div className="form-group">
                  {user?.role === 'admin' && (
                <div className="form-group">
                  <label className="form-label">ROL</label>
                  <select value={form.role || 'student'} onChange={e => setForm({...form, role: e.target.value})} className="form-input">
                    <option value="student">Öğrenci</option>
                    <option value="admin">Admin</option>
                    <option value="manager">Yönetici</option>
                  </select>
                </div>
              )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={() => { setShowModal(false); setCreateError(''); setCreateSuccess(false); }} className="btn-cancel">İptal</button>
              <button onClick={createUser} disabled={createSuccess} className="btn-submit">{createSuccess ? '✓ Oluşturuldu' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      
      {/* --- Sistem Tanımları Modalı --- */}
      {paramsModal && (
        <div className="modal-overlay" style={{ zIndex: 1050 }}>
          <div className="modal-container" style={{ maxWidth: 600 }}>
            <div className="modal-header d-flex justify-between align-center">
              <div>
                <h3 className="modal-title">Sistem Tanımları</h3>
                <p className="modal-subtitle" style={{ fontSize: '13px', marginTop: '4px', color: '#64748b' }}>Açılır listelerdeki standart verileri yönetin.</p>
              </div>
              <button type="button" onClick={() => setParamsModal(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}>✕</button>
            </div>
            <div className="modal-body">
              <div className="tabs-header d-flex gap-2" style={{ borderBottom: '1px solid #eaecf0', marginBottom: '15px' }}>
                {[
                  { id: 'company', label: 'Şirketler' },
                  { id: 'department', label: 'Müdürlükler' },
                  { id: 'unit', label: 'Birimler' },
                  { id: 'title', label: 'Ünvanlar' }
                ].map(tab => (
                  <div 
                    key={tab.id} 
                    onClick={() => setActiveParamTab(tab.id)}
                    style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: activeParamTab === tab.id ? '2px solid #0056b3' : '2px solid transparent', color: activeParamTab === tab.id ? '#0056b3' : '#667085', fontWeight: activeParamTab === tab.id ? '600' : '400', fontSize: '14px' }}
                  >
                    {tab.label} ({sysParams[tab.id]?.length || 0})
                  </div>
                ))}
              </div>

              <form onSubmit={handleAddParam} className="d-flex gap-2 mb-3">
                <input 
                  type="text" 
                  value={newParamValue} 
                  onChange={e => setNewParamValue(e.target.value)} 
                  placeholder="Yeni değer ekle..." 
                  className="form-input" 
                  style={{ flex: 1 }} 
                />
                <button type="submit" className="btn-primary" style={{ padding: '0 16px', borderRadius: '6px', background: '#0056b3', color: 'white', border: 'none', cursor: 'pointer' }}>Ekle</button>
              </form>

              <div style={{ maxHeight: '350px', overflowY: 'auto', border: '1px solid #eaecf0', borderRadius: '6px', padding: '10px' }}>
                {sysParams[activeParamTab]?.map((item, idx) => (
                  <div key={idx} className="d-flex justify-between align-center" style={{ padding: '8px 10px', borderBottom: '1px solid #f1f5f9' }}>
                    <span style={{ fontSize: '14px', color: '#334155' }}>{item}</span>
                    <button type="button" onClick={() => handleDeleteParam(activeParamTab, item)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer' }} title="Sil">
                      <Trash2 size={16} />
                    </button>
                  </div>
                ))}
                {(!sysParams[activeParamTab] || sysParams[activeParamTab].length === 0) && (
                  <div className="text-muted" style={{ padding: '15px', fontSize: '13px', textAlign: 'center' }}>Kayıt bulunamadı.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 2. Düzenleme Modalı */}
      {editModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: 640 }}>
            <div className="modal-header d-flex justify-between align-center">
              <div>
                <h3 className="modal-title">Kullanıcı Düzenle</h3>
                <p className="modal-subtitle">Kullanıcı bilgilerini ve durumunu güncelleyin.</p>
              </div>
              <button onClick={() => setEditModal(null)} className="btn-close-icon">✕</button>
            </div>

            <div className="modal-body">
              <div className="info-banner mb-4">
                <strong>Sicil:</strong> {editModal.username} &nbsp;•&nbsp; <strong>Kullanıcı ID:</strong> {editModal.id}
              </div>

              <div className="form-grid">
                {[
                  ['name', 'Ad Soyad', 'text'], ['username', 'Sicil', 'text'], ['email', 'E-posta', 'email'], 
                  ['phone', 'Telefon', 'text'], ['company', 'Şirket', 'text'], ['department', 'Müdürlük', 'text'], 
                  ['unit', 'Birim / Şeflik', 'text'], ['title', 'Ünvan', 'text']
                ].map(([key, label, type]) => (
                  <div key={key} className="form-group">
                    <label className="form-label">{label}</label>
                    <input type={type} value={editForm[key] ?? ''} onChange={e => setEditForm({...editForm, [key]: e.target.value})} className="form-input" />
                  </div>
                ))}
              </div>

              <div className="form-grid mt-3">
                {isAdmin && (
                  <div className="form-group">
                    <label className="form-label">ROL</label>
                    <select value={editForm.role} onChange={e => setEditForm({...editForm, role: e.target.value})} className="form-input">
                      <option value="student">Öğrenci</option>
                      {user?.role === 'admin' && <option value="admin">Admin</option>}
                      <option value="manager">Yönetici</option>
                    </select>
                  </div>
                )}
                
                <div className="form-group">
                  <label className="form-label">DURUM</label>
                  <div className="d-flex gap-2">
                    {[
                      { val: true, label: '● Aktif', colorClass: 'active' },
                      { val: false, label: '○ Pasif', colorClass: 'passive' }
                    ].map(opt => (
                      <button key={String(opt.val)} type="button" onClick={() => setEditForm({...editForm, is_active: opt.val})} className={`btn-status-toggle ${editForm.is_active === opt.val ? opt.colorClass : ''}`}>
                        {opt.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="password-section">
                <label className="form-label">YENİ PAROLA <span className="text-muted fw-normal ml-1">(boş bırakılırsa değişmez)</span></label>
                <input type="password" value={editForm.password ?? ''} onChange={e => setEditForm({...editForm, password: e.target.value})} placeholder="Yeni parola girin..." autoComplete="new-password" className="form-input" />
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={() => setEditModal(null)} className="btn-cancel">İptal</button>
              <button onClick={saveEdit} disabled={saving} className="btn-submit">{saving ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}

      {/* 3. Güncelleme Başarılı Modalı */}
      {updateSuccess && (
        <div className="modal-overlay" style={{ zIndex: 9999 }}>
          <div className="modal-container text-center" style={{ maxWidth: 400, padding: 32 }}>
            <div className="success-icon-large">✓</div>
            <h3 className="modal-title mb-2">Başarılı</h3>
            <p className="text-muted mb-4">Kullanıcı bilgileri başarıyla güncellendi.</p>
            <button onClick={() => setUpdateSuccess(false)} className="btn-submit w-full">Tamam</button>
          </div>
        </div>
      )}

      {/* 4. Telefon Güncelleme Modalı */}
      {phoneImportData.length > 0 && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: 600 }}>
            <div className="modal-header">
              <h3 className="modal-title">📱 Telefon Güncelleme</h3>
            </div>
            <div className="modal-body">
              <p className="text-muted mb-4">Excel'de SİCİL ve TELEFON bulunan <b>{phoneImportData.length}</b> kayıt algılandı.</p>
              
              <div className="import-preview-list">
                {phoneImportData.slice(0, 100).map((u, i) => (
                  <div key={i} className="preview-list-item">
                    <span><b>{u.username}</b></span>
                    <span>{u.phone}</span>
                  </div>
                ))}
              </div>
              {phoneImportData.length > 100 && <div className="text-muted text-small mt-2">İlk 100 kayıt gösteriliyor.</div>}

              {phoneImportResult && (
                <div className={`alert mt-4 ${phoneImportResult.success ? 'alert-success' : 'alert-danger'}`}>
                  {phoneImportResult.success ? (
                    <>
                      <b>{phoneImportResult.updated} kullanıcı güncellendi.</b>
                      {phoneImportResult.notFound.length > 0 && (
                        <div className="mt-2 text-small">Bulunamayan sicil: <br/>{phoneImportResult.notFound.join(', ')}</div>
                      )}
                    </>
                  ) : phoneImportResult.error }
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button onClick={() => { setPhoneImportData([]); setPhoneImportResult(null); }} className="btn-cancel">Kapat</button>
              {!phoneImportResult?.success && (
                <button onClick={importPhones} disabled={phoneImporting} className="btn-warning">{phoneImporting ? 'Güncelleniyor...' : 'Telefonları Güncelle'}</button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* 5. Toplu Güncelleme Modalı */}
      {bulkUpdateModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: 850 }}>
            <div className="modal-header d-flex justify-between align-center">
              <div>
                <h3 className="modal-title">📤 Excel'den Toplu Güncelleme</h3>
                <p className="modal-subtitle">Eşleştirme SİCİL numarası üzerinden yapılır.</p>
              </div>
              <button onClick={() => { setBulkUpdateModal(false); setBulkUpdateData([]); setBulkUpdatePreview(null); }} className="btn-close-icon">✕</button>
            </div>
            
            <div className="modal-body">
              {bulkUpdatePreview && bulkUpdatePreview.updated === undefined && (
                <>
                  <div className="stats-grid mb-4">
                    <div className="stat-box bg-blue">
                      <div className="stat-num text-blue">{bulkUpdatePreview.total}</div>
                      <div className="stat-text">Excel Kaydı</div>
                    </div>
                    <div className="stat-box bg-green">
                      <div className="stat-num text-green">{bulkUpdatePreview.found}</div>
                      <div className="stat-text">Eşleşen</div>
                    </div>
                    <div className="stat-box bg-orange">
                      <div className="stat-num text-orange">{bulkUpdatePreview.notFound?.length || 0}</div>
                      <div className="stat-text">Bulunamayan</div>
                    </div>
                  </div>
                  
                  {bulkUpdatePreview.notFound?.length > 0 && (
                    <div className="alert-warning mb-4">
                      <strong>Bulunamayan siciller:</strong>
                      <div className="mt-2 text-small max-h-100 overflow-y">{bulkUpdatePreview.notFound.join(', ')}</div>
                    </div>
                  )}
                  {bulkUpdatePreview.duplicate > 0 && (
                    <div className="alert-danger mb-4">⚠️ Excel içinde {bulkUpdatePreview.duplicate} tekrarlanan sicil kaydı var.</div>
                  )}
                  
                  <div className="info-box mb-4">
                    <strong>Güvenlik Kuralları:</strong><br/>
                    • Yalnızca mevcut kullanıcılar güncellenir.<br/>
                    • Sistemde kayıtlı olmayanlar atlanır.<br/>
                    • <strong>Kullanıcı parolalarına asla dokunulmaz.</strong>
                  </div>
                  
                </>
              )}

              {bulkUpdatePreview?.updated !== undefined && (
                <div>
                  <div className="alert-success p-4 mb-4">
                    <h4 className="mb-2">✅ Güncelleme tamamlandı</h4>
                    <p>{bulkUpdatePreview.updated} kullanıcı başarıyla güncellendi.</p>
                  </div>
                  
                  {bulkUpdatePreview.notFound?.length > 0 && (
                    <div className="alert-warning mb-3">
                      <strong>Bulunamayan siciller:</strong>
                      <div className="mt-2 text-small">{bulkUpdatePreview.notFound.join(', ')}</div>
                    </div>
                  )}
                  
                  {bulkUpdatePreview.errors?.length > 0 && (
                    <div className="alert-danger mb-3">
                      <strong>Hatalar:</strong>
                      {bulkUpdatePreview.errors.map((item, index) => (
                        <div key={index} className="mt-1 text-small">{item.username || '-'} — {item.error}</div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
            
            {/* Modal Footer Alanı (Butonlar) */}
            <div className="modal-footer">
              {bulkUpdatePreview && bulkUpdatePreview.updated === undefined ? (
                <>
                  <button onClick={() => { setBulkUpdateModal(false); setBulkUpdateData([]); setBulkUpdatePreview(null); }} className="btn-cancel">İptal</button>
                  <button onClick={executeBulkUpdate} disabled={bulkUpdating || !bulkUpdatePreview.found} className="btn-primary">
                    {bulkUpdating ? 'Güncelleniyor...' : `${bulkUpdatePreview.found} Kullanıcıyı Güncelle`}
                  </button>
                </>
              ) : (
                <button onClick={() => { setBulkUpdateModal(false); setBulkUpdateData([]); setBulkUpdatePreview(null); }} className="btn-primary">Kapat</button>
              )}
            </div>
            
          </div>
        </div>
      )}

      {/* 6. Yeni Kullanıcı Import Modalı */}
      {importModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: 650 }}>
            <div className="modal-header d-flex justify-between align-center">
              <h3 className="modal-title">📥 Excel'den Yeni Kullanıcı Aktar</h3>
              <button onClick={() => { setImportModal(false); setImportData([]); setImportResult(null); }} className="btn-close-icon">✕</button>
            </div>
            
            <div className="modal-body">
              {importResult ? (
                <div>
                  <div className="alert-success mb-3 p-4">
                    <h4 className="mb-2">✅ İçe Aktarma Tamamlandı</h4>
                    <p>{importResult.added} eklendi, {importResult.skipped} atlandı (zaten var).</p>
                  </div>
                  {importResult.errors.length > 0 && (
                    <div className="alert-danger mb-4 p-4">
                      <strong>Hatalar:</strong>
                      {importResult.errors.map((e, i) => <div key={i} className="text-small mt-1">{e}</div>)}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className="info-box mb-4">
                    <strong>Format:</strong> AD SOYAD, SİCİL, PAROLA, E-POSTA, ŞİRKET, MÜDÜRLÜK, UNVAN
                    <span onClick={downloadTemplate} className="text-primary fw-bold cursor-pointer ml-2">📥 Şablon İndir</span>
                  </div>
                  
                  {importData.length > 0 ? (
                    <div>
                      <p className="fw-bold mb-2">{importData.length} uygun kullanıcı bulundu:</p>
                      <div className="import-preview-list mb-4">
                        <table className="modern-table" style={{ minWidth: '100%' }}>
                          <thead>
                            <tr><th>Ad Soyad</th><th>Sicil</th><th>Şirket</th><th>Müdürlük</th></tr>
                          </thead>
                          <tbody>
                            {importData.map((u, i) => (
                              <tr key={i}>
                                <td>{u.name}</td>
                                <td className="text-monospace">{u.username}</td>
                                <td>{u.company}</td>
                                <td>{u.department}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div className="empty-state p-4">Uygun veri bulunamadı. Lütfen şablonu inceleyin.</div>
                  )}
                </div>
              )}
            </div>
            
            {/* Modal Footer */}
            <div className="modal-footer">
              {importResult ? (
                <button onClick={() => { setImportModal(false); setImportData([]); setImportResult(null); }} className="btn-primary">Kapat</button>
              ) : importData.length > 0 ? (
                <>
                  <button onClick={() => { setImportModal(false); setImportData([]); }} className="btn-cancel">İptal</button>
                  <button onClick={importUsers} disabled={importing} className="btn-submit">{importing ? 'Aktarılıyor...' : `${importData.length} Kullanıcıyı Aktar`}</button>
                </>
              ) : null}
            </div>

          </div>
        </div>
      )}

      {/* Silme Onay */}
      <ConfirmModal
        isOpen={confirmModal.open}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={() => { confirmModal.action && confirmModal.action(); }}
        onCancel={closeConfirm}
        confirmText="Evet, Sil"
      />

      <style>{`
        .page-container { animation: fadeSlideUp 0.4s ease-out; }
        @keyframes fadeSlideUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

        /* Typography & Utils */
        .text-muted { color: #6b7280; }
        .text-dark { color: #111827; }
        .text-monospace { font-family: monospace; font-size: 13px; }
        .font-medium { font-weight: 500; }
        .fw-bold { font-weight: 700; }
        .text-truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .white-space-nowrap { white-space: nowrap; }
        .text-small { font-size: 12.5px; }
        .w-full { width: 100%; }
        .mb-2 { margin-bottom: 8px; }
        .mb-3 { margin-bottom: 12px; }
        .mb-4 { margin-bottom: 16px; }
        .mt-1 { margin-top: 4px; }
        .mt-2 { margin-top: 8px; }
        .mt-3 { margin-top: 12px; }
        .mt-4 { margin-top: 16px; }
        .p-4 { padding: 16px; }
        .d-flex { display: flex; }
        .gap-2 { gap: 8px; }
        .flex-1 { flex: 1; }
        .justify-between { justify-content: space-between; }
        .justify-end { justify-content: flex-end; }
        .align-center { align-items: center; }
        .text-center { text-align: center; }
        .cursor-pointer { cursor: pointer; }
        .max-h-100 { max-height: 100px; }
        .overflow-y { overflow-y: auto; }
        .text-primary { color: #007aff; }

        /* Header */
        .page-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; }
        .page-title { margin: 0 0 4px 0; font-size: 22px; font-weight: 700; color: #111827; letter-spacing: -0.5px; }
        .page-subtitle { margin: 0; font-size: 13.5px; color: #6b7280; }

        .header-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; justify-content: flex-end; }

        /* Ana Kart */
        .content-card { background: #ffffff; border-radius: 16px; border: 1px solid #eaecf0; box-shadow: 0 4px 6px -1px rgba(16, 24, 40, 0.03); overflow: hidden; }

        /* Filtre Çubuğu */
        .search-bar-container { padding: 16px 20px; border-bottom: 1px solid #eaecf0; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px; background: #fcfcfd; }
        .search-input-wrapper { position: relative; width: 100%; max-width: 400px; }
        .search-icon { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #9ca3af; }
        .search-input { width: 100%; padding: 10px 14px 10px 38px; border: 1px solid #d0d5dd; border-radius: 10px; font-size: 14px; outline: none; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); transition: all 0.2s; background: white; }
        .search-input:focus { border-color: #e30613; box-shadow: 0 0 0 4px #fff1f2; }
        
        .filter-select-wrapper { position: relative; }
        .filter-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #9ca3af; pointer-events: none;}
        .filter-select { padding: 9px 14px 9px 34px; border: 1px solid #d0d5dd; border-radius: 10px; font-size: 13.5px; outline: none; background: white; color: #374151; cursor: pointer; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); transition: border-color 0.2s;}
        .filter-select:focus { border-color: #e30613; }
        .result-count { font-size: 13px; color: #6b7280; }

        /* Tablo Stilleri */
        .table-responsive { overflow-x: auto; }
        .modern-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
        .modern-table th { padding: 12px 14px; text-align: left; font-size: 11px; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; background: #f9fafb; border-bottom: 1px solid #eaecf0; }
        .modern-table td { padding: 12px 14px; border-bottom: 1px solid #eaecf0; vertical-align: middle; transition: background 0.2s; font-size: 13.5px;}
        .modern-table tr:hover td { background: #f9fafb; }
        .modern-table tr:last-child td { border-bottom: none; }

        .column-filters-row th { padding: 8px; background: #ffffff; border-bottom: 1px solid #eaecf0; }
        .col-filter-input { width: 100%; padding: 8px 10px; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 12px; outline: none; background: #f9fafb; transition: all 0.2s; box-sizing: border-box; }
        .col-filter-input:focus { border-color: #e30613; background: #fff; box-shadow: 0 0 0 3px #fff1f2;}

        .avatar-circle { width: 30px; height: 30px; border-radius: 8px; background: #fff1f2; color: #e30613; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 13px; flex-shrink: 0; }

        /* Badgeler (Etiketler) */
        .badge { display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; white-space: nowrap;}
        .category-badge { background: #f3f4f6; color: #4b5563; border: 1px solid #e5e7eb; }
        .title-badge { background: #f8fafc; color: #475569; border: 1px solid #f1f5f9; }
        .status-active { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; }
        .status-active::before { content: ''; display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: #10b981; margin-right: 6px; }
        .status-passive { background: #f3f4f6; color: #6b7280; border: 1px solid #e5e7eb; }
        .status-passive::before { content: ''; display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: #9ca3af; margin-right: 6px; }

        /* Butonlar */
        .action-buttons { display: flex; align-items: center; gap: 8px; }
        .btn-primary { background: #e30613; color: white; border: 1px solid #e30613; border-radius: 10px; padding: 9px 16px; cursor: pointer; font-weight: 600; font-size: 13.5px; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); transition: all 0.2s; white-space: nowrap; }
        .btn-primary:hover { background: #ba000a; border-color: #ba000a; transform: translateY(-1px); box-shadow: 0 4px 6px rgba(227, 6, 19, 0.2); }
        .btn-primary:disabled { background: #fca5a5; border-color: #fca5a5; cursor: not-allowed; transform: none; }
        
        .btn-outline-blue { background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 10px; padding: 9px 16px; cursor: pointer; font-weight: 600; font-size: 13.5px; display: flex; align-items: center; gap: 6px; transition: all 0.2s; white-space: nowrap; }
        .btn-outline-blue:hover { background: #dbeafe; border-color: #93c5fd; }
        
        .btn-outline-green { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; border-radius: 10px; padding: 9px 16px; cursor: pointer; font-weight: 600; font-size: 13.5px; display: flex; align-items: center; gap: 6px; transition: all 0.2s; white-space: nowrap; }
        .btn-outline-green:hover { background: #dcfce7; border-color: #86efac; }
        
        .btn-outline-orange { background: #fff7ed; color: #ea580c; border: 1px solid #fed7aa; border-radius: 10px; padding: 9px 16px; cursor: pointer; font-weight: 600; font-size: 13.5px; display: flex; align-items: center; gap: 6px; transition: all 0.2s; white-space: nowrap; }
        .btn-outline-orange:hover { background: #ffedd5; border-color: #fdba74; }

        .btn-outline-indigo { background: #eef2ff; color: #4f46e5; border: 1px solid #c7d2fe; border-radius: 10px; padding: 9px 16px; cursor: pointer; font-weight: 600; font-size: 13.5px; display: flex; align-items: center; gap: 6px; transition: all 0.2s; white-space: nowrap; }
        .btn-outline-indigo:hover { background: #e0e7ff; border-color: #a5b4fc; }

        .btn-cancel { padding: 10px 16px; border: 1px solid #d0d5dd; background: #ffffff; border-radius: 10px; cursor: pointer; font-weight: 600; font-size: 14px; color: #344054; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); transition: all 0.2s; }
        .btn-cancel:hover { background: #f9fafb; border-color: #98a2b3; }

        .btn-submit { padding: 10px 20px; background: #e30613; color: #ffffff; border: 1px solid #e30613; border-radius: 10px; cursor: pointer; font-weight: 600; font-size: 14px; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); transition: all 0.2s; }
        .btn-submit:hover { background: #ba000a; border-color: #ba000a; }
        .btn-submit:disabled { opacity: 0.7; cursor: not-allowed; }

        .btn-icon-edit { background: #eff6ff; color: #2563eb; border: 1px solid #dbeafe; border-radius: 8px; padding: 6px; cursor: pointer; display: flex; align-items: center; transition: all 0.2s; }
        .btn-icon-edit:hover { background: #dbeafe; border-color: #bfdbfe; }
        .btn-icon-danger { background: #fef2f2; color: #ef4444; border: 1px solid #fee2e2; border-radius: 8px; padding: 6px; cursor: pointer; display: flex; align-items: center; transition: all 0.2s; }
        .btn-icon-danger:hover { background: #fee2e2; border-color: #fca5a5; }
        .btn-close-icon { background: #f3f4f6; border: none; border-radius: 8px; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; color: #6b7280; font-size: 18px; cursor: pointer; transition: all 0.2s; }
        .btn-close-icon:hover { background: #e5e7eb; color: #111827; }

        /* Modal Stilleri */
        .modal-overlay { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.5); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; }
        .modal-container { background: #ffffff; border-radius: 20px; width: 100%; max-width: 500px; box-shadow: 0 20px 24px -4px rgba(16, 24, 40, 0.08); animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); display: flex; flex-direction: column; height: fit-content; max-height: 90vh; overflow: hidden; }
        @keyframes modalPop { from { opacity: 0; transform: scale(0.95) translateY(10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        .modal-header { padding: 24px 28px 16px; border-bottom: 1px solid #eaecf0; flex-shrink: 0;}
        .modal-title { margin: 0 0 4px 0; font-size: 19px; font-weight: 700; color: #111827; }
        .modal-subtitle { margin: 0; font-size: 13.5px; color: #6b7280; }
        .modal-body { padding: 24px 28px; overflow-y: auto; flex: 1 1 auto;}
        .modal-footer { padding: 16px 28px; background: #f9fafb; border-top: 1px solid #eaecf0; display: flex; justify-content: flex-end; gap: 12px; flex-shrink: 0;}

        /* Form Stilleri (Modal İçi) */
        .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 12px; }
        @media (max-width: 640px) { .form-grid { grid-template-columns: 1fr; } }
        .span-full { grid-column: 1 / -1; }
        .form-group { margin-bottom: 0; }
        .form-label { display: block; margin-bottom: 5px; font-weight: 600; font-size: 11.5px; color: #475467; text-transform: uppercase; letter-spacing: 0.5px;}
        .form-input { width: 100%; padding: 9px 12px; border: 1px solid #d0d5dd; border-radius: 10px; font-size: 14px; outline: none; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); transition: all 0.2s; box-sizing: border-box; background: white;}
        .form-input:focus { border-color: #e30613; box-shadow: 0 0 0 4px #fff1f2; }

        .btn-status-toggle { flex: 1; padding: 10px 12px; border: 1px solid #d0d5dd; border-radius: 10px; background: white; cursor: pointer; font-weight: 600; font-size: 13px; color: #6b7280; transition: all 0.2s; }
        .btn-status-toggle.active { background: #ecfdf5; border-color: #10b981; color: #059669; }
        .btn-status-toggle.passive { background: #f3f4f6; border-color: #9ca3af; color: #4b5563; }
        
        .password-section { margin-top: 24px; padding-top: 20px; border-top: 1px solid #eaecf0; }
        .info-banner { padding: 12px 16px; border-radius: 10px; background: #fff1f2; color: #e30613; font-size: 13.5px; border: 1px solid #ffe4e6; }
        
        /* İçe Aktarma / Toplu Güncelleme Önizleme */
        .import-preview-list { max-height: 250px; overflow-y: auto; border: 1px solid #eaecf0; border-radius: 10px; background: #fff; }
        .preview-list-item { display: flex; justify-content: space-between; padding: 10px 14px; border-bottom: 1px solid #f2f4f7; font-size: 13px; color: #344054;}
        .preview-list-item:last-child { border-bottom: none; }
        
        .stats-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
        .stat-box { padding: 16px; border-radius: 12px; text-align: center; }
        .stat-num { font-size: 28px; font-weight: 700; line-height: 1.2; margin-bottom: 4px; }
        .stat-text { font-size: 13px; font-weight: 500; }
        .bg-blue { background: #eff6ff; } .text-blue { color: #2563eb; } .stat-box.bg-blue .stat-text { color: #1e3a8a; }
        .bg-green { background: #f0fdf4; } .text-green { color: #16a34a; } .stat-box.bg-green .stat-text { color: #14532d; }
        .bg-orange { background: #fff7ed; } .text-orange { color: #ea580c; } .stat-box.bg-orange .stat-text { color: #7c2d12; }

        /* Alerts & Empty States */
        .alert-success { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; padding: 12px 16px; border-radius: 10px; font-size: 13.5px; display: flex; align-items: center; gap: 8px;}
        .alert-danger { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; padding: 12px 16px; border-radius: 10px; font-size: 13.5px; display: flex; align-items: center; gap: 8px;}
        .alert-warning { background: #fff7ed; border: 1px solid #fed7aa; color: #9a3412; padding: 12px 16px; border-radius: 10px; font-size: 13.5px; }
        .success-icon-large { width: 64px; height: 64px; border-radius: 50%; background: #ecfdf5; color: #10b981; display: flex; align-items: center; justify-content: center; font-size: 32px; font-weight: bold; margin: 0 auto 16px; }
        .empty-state { text-align: center; padding: 40px !important; color: #6b7280; font-size: 14px; font-style: italic; }

        /* Pagination */
        .pagination-container { padding: 16px 20px; border-top: 1px solid #eaecf0; display: flex; align-items: center; gap: 12px; justify-content: center; background: #fcfcfd; }
        .btn-pagination { padding: 8px 16px; border: 1px solid #d0d5dd; border-radius: 8px; background: white; cursor: pointer; font-size: 13px; font-weight: 600; color: #344054; transition: all 0.2s; box-shadow: 0 1px 2px rgba(16,24,40,0.05); }
        .btn-pagination:hover:not(:disabled) { background: #f9fafb; border-color: #9ca3af; }
        .btn-pagination:disabled { opacity: 0.5; cursor: not-allowed; }
        .pagination-info { font-size: 13.5px; font-weight: 600; color: #475467; }
      `}</style>
    </AdminLayout>
  );
}
